var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1348 7.83287H5.2281L7.6481 4.9262C7.76126 4.79005 7.8157 4.61453 7.79945 4.43825C7.78319 4.26197 7.69758 4.09936 7.56143 3.9862C7.42529 3.87304 7.24977 3.8186 7.07348 3.83485C6.8972 3.85111 6.73459 3.93672 6.62143 4.07287L3.2881 8.07287C3.26567 8.10468 3.24562 8.13811 3.2281 8.17287C3.2281 8.2062 3.2281 8.2262 3.18143 8.25953C3.15121 8.33597 3.13539 8.41734 3.13477 8.49953C3.13539 8.58173 3.15121 8.66309 3.18143 8.73953C3.18143 8.77287 3.18143 8.79287 3.2281 8.8262C3.24562 8.86096 3.26567 8.89438 3.2881 8.9262L6.62143 12.9262C6.68411 13.0015 6.76261 13.062 6.85133 13.1035C6.94005 13.1449 7.03683 13.1664 7.13477 13.1662C7.29053 13.1665 7.44149 13.1123 7.56143 13.0129C7.62894 12.9569 7.68474 12.8882 7.72564 12.8106C7.76654 12.733 7.79174 12.6482 7.79979 12.5608C7.80784 12.4735 7.79859 12.3855 7.77256 12.3017C7.74653 12.218 7.70423 12.1402 7.6481 12.0729L5.2281 9.1662H13.1348C13.3116 9.1662 13.4811 9.09596 13.6062 8.97094C13.7312 8.84591 13.8014 8.67634 13.8014 8.49953C13.8014 8.32272 13.7312 8.15315 13.6062 8.02813C13.4811 7.9031 13.3116 7.83287 13.1348 7.83287Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.9955aea48591af294f9276c16911ad6a.svg";
export { ForwardRef as ReactComponent };